import {
  BUTTON_BORDER_RADIUS,
  BUTTON_FONT_WEIGHT,
  DEFAULT_BUTTON_SIZE,
  resolveButtonSizeFontSize,
} from "./button-presentation";
import { uid } from "../create-shared";
import type { ButtonBlock } from "../types";
import type { BlockDefinition } from "./types";

export function createButtonBlock(): ButtonBlock {
  return {
    id: uid(),
    type: 'button',
    text: 'Click here',
    href: '',
    align: 'center',
    borderWidth: 0,
    fontSize: resolveButtonSizeFontSize(DEFAULT_BUTTON_SIZE),
    fontWeight: BUTTON_FONT_WEIGHT,
    borderRadius: { ...BUTTON_BORDER_RADIUS },
    size: DEFAULT_BUTTON_SIZE,
    fullWidth: false,
    fullWidthMobile: true,
    padding: { top: 16, right: 0, bottom: 16, left: 0 },
  };
}

export const buttonBlockDefinition: BlockDefinition = {
  type: 'button',
  label: 'Button',
  create: createButtonBlock,
};
